"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasFieldError = hasFieldError;
exports.isErrorEmpty = isErrorEmpty;
exports.omitFormProps = omitFormProps;
exports.trimAny = trimAny;
exports.trimOnNeeds = trimOnNeeds;
var _omit = _interopRequireDefault(require("lodash/fp/omit"));
var _isString = _interopRequireDefault(require("lodash/fp/isString"));
var _mapValues = _interopRequireDefault(require("lodash/fp/mapValues"));
var _map = _interopRequireDefault(require("lodash/fp/map"));
var _values = _interopRequireDefault(require("lodash/fp/values"));
var _every = _interopRequireDefault(require("lodash/fp/every"));
var _trim = _interopRequireDefault(require("lodash/fp/trim"));
var _isObject = _interopRequireDefault(require("lodash/fp/isObject"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _isObjectLike = _interopRequireDefault(require("lodash/fp/isObjectLike"));
function omitFormProps(props) {
  return (0, _omit["default"])(['form', 'registerValidate', 'required', 'onTouched', 'withoutLayout', 'hasError', 'hasWarning', 'initialValue'])(props);
}
function hasFieldError(error, touched) {
  return (0, _isString["default"])(error) && !!(error && touched);
}
function isErrorEmpty(error) {
  if ((0, _isObject["default"])(error)) {
    return (0, _compose["default"])((0, _every["default"])(isErrorEmpty), _values["default"])(error);
  }
  return !error;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function trimAny(value) {
  if (typeof value === 'string') {
    return (0, _trim["default"])(value);
  }
  if (Array.isArray(value)) {
    return (0, _map["default"])(trimAny)(value);
  }
  if ((0, _isObjectLike["default"])(value)) {
    return (0, _mapValues["default"])(trimAny)(value);
  }
  return value;
}
function trimOnNeeds(v, trimInput) {
  return trimInput ? trimAny(v) : v;
}